"use client";

import { useMediaQuery } from "./useMediaQuery";

interface BreakpointState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

/**
 * Resolve the active design-system breakpoint via media queries. Mirrors the
 * tokens used in `tailwind.scss`:
 *   - mobile  : `<1024px`
 *   - tablet  : `1024-1279px`
 *   - desktop : `≥1280px`
 *
 * Returns `false`/`false`/`false` during SSR — components that need to avoid
 * a hydration flash should also rely on CSS breakpoints for the initial paint
 * rather than gating the entire markup on this hook.
 */
const useBreakpoint = (): BreakpointState => {
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const isTablet = useMediaQuery("(min-width: 1024px) and (max-width: 1279px)");
  const isDesktop = useMediaQuery("(min-width: 1280px)");
  return { isMobile, isTablet, isDesktop };
};

export default useBreakpoint;
